export default __webpack_public_path__ + "static/Poppins-ExtraLight-333cb30c20e31999802abfb3d9816ee0.ttf";